export default "/images/vendor/flag-icons/flags/4x3/bz.svg?c3d1b0988bff7cae978dd55ea41277e7";